






























































































































/* 
  manualEvaluate 手工评价
*/
import { Vue, Component, Prop } from "vue-property-decorator";
//引入接口调用函数
import { manualEvaluate } from "../../../../api/markingTeacherEvaluate";
import { Form as ElForm } from "element-ui";
import { ruleNormal } from "../../../../utils/common";
interface DetailForm {
  [propName: string]: any;
}
@Component({
  name: "teacherEvaluate"
})
export default class extends Vue {
  @Prop(Object) evaluateDetail!: DetailForm;
  private evaluateInfo: object = {}; //表单数据
  private imageUrl: string = ""; //
  private editFormRules: object = {
    otherinfoIsExcellentTeacher: [ruleNormal("必填项")],
    otherinfoIsRecommend: [ruleNormal("必填项")],
    evaluateContent: [ruleNormal("必填项")]
  };
  
  private rateList = 0;
  created() {
    this.imageUrl =
      window.config.baseUrl4Shool + this.evaluateDetail.teacherPhotoPath;
  }

  //“确认保存”处理
  private async saveHandle() {
    let params = {
      evaluateContent: this.evaluateDetail.evaluateContent, //评价内容
      evaluateStar: this.evaluateDetail.evaluateStar, //评价星级
      otherinfoIsExcellentTeacher: this.evaluateDetail
        .otherinfoIsExcellentTeacher, //是否优秀教师 0:是 1:否
      otherinfoIsRecommend: this.evaluateDetail.otherinfoIsRecommend, //是否重点推荐 0:是 1:否
      projectId: this.evaluateDetail.projectId, //项目id
      teacherId: this.evaluateDetail.teacherId, //教师id
      subjectId: this.evaluateDetail.subjectId //科目id
    };
    (this.$refs.evaluateDetail as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          await manualEvaluate(params);
          this.$message.success("保存成功");
        } catch (error) {
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      } else {
        this.$message.error("请填写全部内容");
      }
    });
  }
  //返回处理
  private backHandle() {
    //关闭评价详情页
    (this.$parent as any).showTeacherEvaluate = false;
    //重新获取数据
    (this.$parent as any).getData();
    //清空勾选的记录
    (this.$parent as any).chooseIdArray = [];
  }
  //可以设置为无星级
  private changeRate(val) {
    if(this.rateList == val) {
       this.evaluateDetail.evaluateStar--;
       this.rateList = this.evaluateDetail.evaluateStar
    }else {
      this.rateList = val
    }
  }
}
